import Vue from "vue";
import Router from "vue-router";
import RouteNames from "./RouteNames";

import Startpage from "@/components/Startpage.vue";
import DataView from "@/components/DataView.vue";
import TheAboutPage from "@/components/TheAboutPage.vue";
import FileCenter from "@/components/FileCenter.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: { name: RouteNames.HOME }
    },
    {
      path: "/home",
      name: RouteNames.HOME,
      component: Startpage,
      meta: {
        toolbarTitle: "Startseite"
      }
    },
    {
      path: "/data/:kind",
      name: RouteNames.DATAVIEW,
      component: DataView,
      meta: {
        toolbarTitle: "Daten"
      },
      beforeEnter(to, _from, next) {
        if (!to.params.kind) {
          next({ name: RouteNames.HOME });
        } else {
          next();
        }
      },
      props: route => ({
        routeName: route.params.kind
      })
    },
    // {
    //   path: "/data-view-admin",
    //   name: RouteNames.DATAVIEWADMIN,
    //   component: DataViewAdmin,
    //   meta: {
    //     toolbarTitle: "DataViewAdmin"
    //   }
    // },
    {
      path: "/about",
      name: RouteNames.ABOUT,
      component: TheAboutPage,
      meta: {
        toolbarTitle: "Impressum"
      }
    },
    // {
    //   path: "/files",
    //   name: RouteNames.FILES,
    //   component: FileCenter,
    //   meta: {
    //     toolbarTitle: "Dateiablage"
    //   }
    // },
    {
      path: "/*",
      redirect: { name: RouteNames.HOME }
    }
  ]
});
